/* IMPORT */
import Owner from './owner.js';
/* MAIN */
class SuperRoot extends Owner {
    constructor() {
        /* VARIABLES */
        super(...arguments);
        this.context = {};
    }
}
//move here to fix circle deps
export let SUPER_OWNER = new SuperRoot();
export let OWNER = SUPER_OWNER;
export const setOwner = (value) => OWNER = value;
export default SuperRoot;
